import { ShieldOff } from 'lucide-react';
import { Button } from '@/components/Button';
import { Dialog, DialogButtonGroup, DialogClose } from '@/components/Dialog';
import { Icon } from '@/components/Icon';
import { EmbeddedWarningToast } from '@/components/Toasts';

type MfaResetTarget = {
    name: string;
};

type MfaResetDialogProps = {
    target: MfaResetTarget | null;
    isSubmitting: boolean;
    onOpenChange: (open: boolean) => void;
    onSubmit: () => Promise<void>;
    /**
     * Renders self-facing copy for the caller resetting their own MFA. When
     * omitted, the dialog uses the admin-facing copy naming `target`.
     */
    isSelf?: boolean;
};

export function MfaResetDialog({ target, isSubmitting, onOpenChange, onSubmit, isSelf = false }: MfaResetDialogProps) {
    return (
        <Dialog title="MFAをリセットする" open={target !== null} onOpenChange={onOpenChange}>
            <EmbeddedWarningToast
                title="ご注意ください"
                message={
                    isSelf
                        ? '登録済みの多要素認証（MFA）がすべて削除されます。次回ログイン時に再設定が必要になります。'
                        : '登録済みの多要素認証（MFA）がすべて削除されます。ユーザーは次回ログイン時に再設定が必要になります。'
                }
            />
            <p>
                {isSelf ? (
                    'ご自身のMFAをリセットします。よろしいですか？'
                ) : (
                    <>
                        <strong>{target?.name}</strong> さんのMFAをリセットします。よろしいですか？
                    </>
                )}
            </p>

            <DialogButtonGroup>
                <DialogClose>
                    <Button type="button" variant="secondary">
                        キャンセル
                    </Button>
                </DialogClose>

                <Button type="button" variant="danger" onClick={onSubmit} disabled={isSubmitting}>
                    {isSubmitting ? (
                        'リセット中...'
                    ) : (
                        <>
                            <Icon icon={ShieldOff} size="sm" />
                            <span>リセットする</span>
                        </>
                    )}
                </Button>
            </DialogButtonGroup>
        </Dialog>
    );
}
